// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.store-addons-for-woocommerce-navbar.store-addons-for-woocommerce-horizontal-navbar {
  /* Horizontal Navbar specific styles can go here */
}
.store-addons-for-woocommerce-navbar.store-addons-for-woocommerce-horizontal-navbar .multi-level-dropdown {
  position: relative;
}
.store-addons-for-woocommerce-navbar.store-addons-for-woocommerce-horizontal-navbar .dropdown-submenu .dropdown-toggle::after {
  float: right;
  margin-top: 10px;
}
.store-addons-for-woocommerce-navbar.store-addons-for-woocommerce-horizontal-navbar .header-icon-menu button {
  padding: 0 !important;
  width: 32px;
  height: 32px;
  line-height: 32px;
}
.store-addons-for-woocommerce-navbar.store-addons-for-woocommerce-horizontal-navbar .header-icon-menu button svg {
  width: 16px;
  height: 16px;
  display: inline-block;
}
.store-addons-for-woocommerce-navbar.store-addons-for-woocommerce-horizontal-navbar {
  /* =====================================
             Desktop
          ===================================== */
}
@media (min-width: 992px) {
  .store-addons-for-woocommerce-navbar.store-addons-for-woocommerce-horizontal-navbar .dropdown-submenu > .dropdown-menu {
    position: absolute;
    top: 0;
    left: 100%;
    margin-top: -1px;
  }
}
.store-addons-for-woocommerce-navbar.store-addons-for-woocommerce-horizontal-navbar {
  /* =====================================
             Mobile / Tablet
          ===================================== */
}
@media (max-width: 991px) {
  .store-addons-for-woocommerce-navbar.store-addons-for-woocommerce-horizontal-navbar .dropdown-submenu > .dropdown-menu {
    position: static !important;
    transform: none !important;
    margin-left: 15px;
    border: none;
    background: rgba(255, 255, 255, 0.03);
  }
  .store-addons-for-woocommerce-navbar.store-addons-for-woocommerce-horizontal-navbar .dropdown-menu {
    width: 100%;
  }
}
.store-addons-for-woocommerce-navbar.store-addons-for-woocommerce-vertical-navbar .vertical-menu-parent {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
.store-addons-for-woocommerce-navbar a:focus {
  box-shadow: none;
  border-radius: 0;
}
.store-addons-for-woocommerce-navbar .dropdown-menu[data-bs-popper] {
  margin-top: 0;
  margin-left: 0;
  padding: 0;
}
.store-addons-for-woocommerce-navbar .dropdown-menu .dropdown-item,
.store-addons-for-woocommerce-navbar .dropdown-menu .dropdown-toggle {
  padding: 0.5rem;
}
.store-addons-for-woocommerce-navbar .current,
.store-addons-for-woocommerce-navbar .active {
  background-color: var(--wp-active-color);
  color: #fff !important;
}
.store-addons-for-woocommerce-navbar .nav-link .nav-icon {
  display: inline-block;
  margin-right: 5px;
}
.store-addons-for-woocommerce-navbar .nav-link.current, .store-addons-for-woocommerce-navbar .nav-link.active {
  background-color: var(--wp-active-color);
  color: #fff !important;
}
.store-addons-for-woocommerce-navbar .wp-has-current-submenu > .dropdown > .nav-link, .store-addons-for-woocommerce-navbar .wp-has-current-submenu > .dropdown-submenu > .nav-link {
  background-color: var(--wp-active-color);
  color: #fff !important;
}/*# sourceMappingURL=Menu.css.map */`, "",{"version":3,"sources":["webpack://./src/components/Menu/Menu.scss","webpack://./src/components/Menu/Menu.css"],"names":[],"mappings":"AACI;EACI,kDAAA;ACAR;ADCQ;EACI,kBAAA;ACCZ;ADEQ;EACI,YAAA;EACA,gBAAA;ACAZ;ADGY;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;ACDhB;ADEgB;EACI,WAAA;EACA,YAAA;EACA,qBAAA;ACApB;ADnBI;EAwBI;;iDAAA;ACAR;ADIQ;EAEI;IAEI,kBAAA;IAEA,MAAA;IAEA,UAAA;IAEA,gBAAA;ECPd;AACF;ADhCI;EA4CI;;iDAAA;ACPR;ADWQ;EAEI;IAEI,2BAAA;IAEA,0BAAA;IAEA,iBAAA;IAEA,YAAA;IAEA,qCAAA;ECfd;EDmBU;IAEI,WAAA;EClBd;AACF;ADwBQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;ACtBZ;ADyBI;EACI,gBAAA;EACA,gBAAA;ACvBR;AD0BQ;EACI,aAAA;EACA,cAAA;EACA,UAAA;ACxBZ;AD0BQ;;EAEI,eAAA;ACxBZ;AD6BI;;EAEI,wCAAA;EACA,sBAAA;AC3BR;AD8BQ;EACI,qBAAA;EACA,iBAAA;AC5BZ;AD+BQ;EAEI,wCAAA;EACA,sBAAA;AC9BZ;ADqCY;EACI,wCAAA;EACA,sBAAA;ACnChB,CAAA,mCAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
